export default function useFormUtils(form: any) {
  return {
    trim(field: string) {
      if (form[field] && form[field].trim) {
        form[field] = (form[field] as string).trim();
      }
    },
  };
}
